var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import Styles from './select-styles.scss';
import { SpanRequired } from '..';
import colors from '../../styles/colors.scss';
import chroma from 'chroma-js';
const colorStyles = {
    control: styles => (Object.assign(Object.assign({}, styles), { backgroundColor: colors.grayInput, borderRadius: 24, border: 'none', height: 52, padding: '10px 16px', textAlign: 'left' })),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = chroma((colors === null || colors === void 0 ? void 0 : colors.dragDropBlue) || '#00a3ff');
        return Object.assign(Object.assign({}, styles), { backgroundColor: isDisabled
                ? undefined
                : isSelected
                    ? colors.dragDropBlue
                    : isFocused
                        ? color.alpha(0.06).css()
                        : undefined, color: isDisabled ? '#ccc' : isSelected ? (chroma.contrast(color, 'white') > 2 ? 'white' : 'black') : 'black', cursor: isDisabled ? 'not-allowed' : 'pointer', borderRadius: 16, ':active': Object.assign(Object.assign({}, styles[':active']), { backgroundColor: !isDisabled ? (isSelected ? colors.dragDropBlue : color.alpha(0.3).css()) : undefined }), textAlign: 'left' });
    },
    menu: styles => (Object.assign(Object.assign({}, styles), { boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08)', borderRadius: 16, padding: 8, zIndex: 9999 })),
    menuList: styles => (Object.assign(Object.assign({}, styles), { gap: 4 })),
    valueContainer: styles => (Object.assign(Object.assign({}, styles), { padding: 0, margin: 0 })),
    dropdownIndicator: styles => (Object.assign(Object.assign({}, styles), { color: colors.dragDropBlue, cursor: 'pointer' })),
    indicatorSeparator: styles => (Object.assign(Object.assign({}, styles), { display: 'none' })),
    placeholder: styles => (Object.assign(Object.assign({}, styles), { fontSize: 14.5, color: colors.lightGray })),
    clearIndicator: styles => (Object.assign(Object.assign({}, styles), { color: colors.lightGray, cursor: 'pointer' }))
};
const AppSelect = (_a) => {
    var { name, state, label, placeholder, required, options, showError = false, isDisabled = false, isSearchable = false, isLoading = false, onChangeAditionalSetState = {} } = _a, props = __rest(_a, ["name", "state", "label", "placeholder", "required", "options", "showError", "isDisabled", "isSearchable", "isLoading", "onChangeAditionalSetState"]);
    const inputRef = useRef(null);
    const error = state[`${name}Error`];
    const isFormDirty = state.dirtyFields ? state.dirtyFields[name] : true;
    const [auxSelected, setAuxSelected] = useState({ label: '', value: '' });
    const LabelInput = () => {
        return (React.createElement("label", { className: Styles.label, "data-testid": `${name}-label`, onClick: () => {
                if (!label)
                    inputRef.current.focus();
            }, title: error },
            label || placeholder,
            " ",
            required && React.createElement(SpanRequired, null)));
    };
    useEffect(() => {
        if (state[`${name}`] !== null) {
            setAuxSelected(state[`${name}`]);
        }
    }, [state[`${name}`]]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Styles.wrapper, "data-testid": `${name}-wrap`, "data-status": error && isFormDirty ? 'invalid' : 'valid' },
            React.createElement(LabelInput, null),
            React.createElement(Select, { options: options, ref: inputRef, value: state[`${name}`] !== null ? auxSelected : '', className: Styles.select, placeholder: placeholder, styles: colorStyles, isSearchable: isSearchable, isClearable: true, isDisabled: isDisabled, isLoading: isLoading, onChange: (e) => {
                    props.setState(Object.assign(Object.assign(Object.assign({}, state), { [name]: e || null, dirtyFields: Object.assign(Object.assign({}, state.dirtyFields), { [name]: true }) }), onChangeAditionalSetState));
                } }),
            error && isFormDirty && showError && (React.createElement("span", { "data-testid": `${name}-error-label`, className: Styles.spanError }, error)))));
};
export default AppSelect;
